<template>
  <v-container fluid>
    <v-row>
      <!-- filter -->
      <v-col cols="12" md="3">
        <wapi-panel :title="'Просмотр станций'">
          <template v-slot:content>
            <v-form ref="form">
              <v-checkbox v-model="showStations" :label="`Отображение станций на карте`" dense>
                <template v-slot:label>
                  <div style="display: block;">
                    <div>Отображение станций на карте</div>
                    <div class="text-caption">может занять время</div>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="clusterization" :label="`Отображение станций на карте`" dense>
                <template v-slot:label>
                  <div style="display: block;">
                    <div>Использовать кластеризацию</div>
                  </div>
                </template>
              </v-checkbox>
              <div>Всего станций: {{ stations.length }}</div>
            </v-form>
          </template>
        </wapi-panel>
      </v-col>
      <!-- query props -->
      <v-col cols="12" md="9">
        <wapi-panel :title="'Настройки запроса'" :spacing="false">
          <template v-slot:content>
            <!-- map -->
            <v-row>
              <v-col class="py-0">
                <div style="height: 415px;">
                  <l-map
                    ref="map"
                    :zoom="13"
                    :center="center"
                    @click="click"
                    :class="'wapi_map__map'"
                  >
                    <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-geo-json ref="geoJsonLayer" :geojson="geojson" :options="geoJsonOptions" />
                    <l-marker v-if="requestType === 1" :lat-lng="[latitude, longitude]"></l-marker>
                    <template v-if="showStations">
                      <l-marker-cluster>
                        <l-marker
                          v-for="marker in markers"
                          v-bind:key="marker.index"
                          :lat-lng="marker.latLng"
                          :radius="3"
                          color="#4334eb"
                          @click="markerClick(marker)"
                          :fillColor="marker.fillColor"
                          :fillOpacity="1"
                        ></l-marker>
                      </l-marker-cluster>
                    </template>
                  </l-map>
                </div>
              </v-col>
            </v-row>
            <!-- params -->
            <v-row>
              <v-col>
                <v-select
                  v-model="requestType"
                  :items="requestTypes"
                  item-text="name"
                  item-value="id"
                  label="Тип запроса"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="pl-4">
              <v-col cols="3">
                <wapi-date-picker v-model="from" label="Начальная дата"></wapi-date-picker>
                <wapi-date-picker v-model="to" label="Конечная дата"></wapi-date-picker>
              </v-col>
              <!-- latlng -->
              <v-col cols="3" v-if="isPoint">
                <v-text-field v-model="latitude" label="Широта" type="number"></v-text-field>
                <v-text-field v-model="longitude" label="Долгота" type="number"></v-text-field>
              </v-col>
              <v-col cols="3" v-if="isStation">
                <v-autocomplete
                  v-model="stationId"
                  :items="stations"
                  item-text="index"
                  item-value="index"
                  label="Станция"
                  :disabled="!showStations"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- buttons -->
            <v-row class="pl-2">
              <v-col>
                <v-btn class="ma-2" color="primary" @click="loadResult()">Выполнить запрос</v-btn>
              </v-col>
            </v-row>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
    <v-row class="ml-2">
      <v-col>
        <wapi-panel :title="'Результаты'" :spacing="false">
          <template v-slot:content>
            <v-tabs background-color="primary" dark>
              <v-tab>Таблица</v-tab>
              <v-tab>JSON</v-tab>
              <v-tab-item>
                <synop-measurement v-model="result" />
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <json-viewer :value="json" copyable expanded :expand-depth="5" boxed sort></json-viewer>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract";
import rules from "../../models/helpers/rules";
import settings from "../../settings.json";
import { datePickerDate } from "../../helpers/common.js";
import WapiPanel from "../../components/WapiPanel.vue";
import SynopMeasurement from "../../components/synop/SynopMeasurement.vue";
import WapiDatePicker from "../../components/WapiDatePicker.vue";
import SynopStationVievModel from "../../models/viewmodels/synop/SynopStationViewModel.js";
import L from "leaflet";
import { SynopRequestType } from "../../models/synop/SynopRequestType.js";

export default {
  name: "SynopView",
  title: "Данные",
  components: {
    WapiPanel,
    WapiDatePicker,
    SynopMeasurement
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    await this.$store.dispatch("FETCH_SYNOP_STATIONS", {
      take: 20000,
      skip: 0
    });
    this.requestTypes = await this.$store.dispatch("FETCH_SYNOP_REQUEST_TYPES");
    this.users = this.$store.getters.USERS;
    this.stations = this.$store.getters.SYNOP_STATIONS;
    this.markers = this.stations.map(
      x => new SynopStationVievModel(x.index, L.latLng(x.latitude, x.longitude))
    );
  },
  data: function() {
    return {
      markerLatLng: settings.center,
      from: datePickerDate(),
      to: datePickerDate(),
      stations: [],
      menuDateStart: false,
      menuDateEnd: false,
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      users: [],
      userId: "",
      stationId: "",
      latitude: settings.center[0],
      longitude: settings.center[1],
      geojson: null,
      valid: true,
      rules: rules,
      center: settings.center,
      result: [],
      lastTime: null,
      json: {},
      markers: [],
      selected: {},
      showStations: false,
      clusterization: true,
      requestTypes: [],
      requestType: SynopRequestType.Point,
      iconSelectedMarker: L.icon({
        iconUrl: "/marker-icon-red.png"
      }),
      markerVisible: true
    };
  },
  computed: {
    isStation() {
      return this.requestType === SynopRequestType.Station;
    },
    isPoint() {
      return this.requestType === SynopRequestType.Point;
    }
  },
  methods: {
    pointMarkerClick() {},
    markerClick(marker) {
      this.stationId = marker.id;
    },
    async loadResult() {
      await this.$store.dispatch("SET_LOADING", true);
      if (this.isPoint) {
        const params = {
          lat: this.latitude,
          lon: this.longitude,
          from: this.from,
          to: this.to
        };
        this.result = await this.$store.dispatch(
          "FETCH_SYNOP_MEASUREMENTS_LOCATION",
          params
        );
      } else {
        const stationParams = {
          indexes: this.stationId,
          from: this.from,
          to: this.to
        };

        this.result = await this.$store.dispatch(
          "FETCH_SYNOP_MEASUREMENTS",
          stationParams
        );
      }

      this.json = this.result;

      if (!this.json) {
        await this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Нет данных для отображения"
        );
        await this.$store.dispatch("SET_LOADING", false);
        return;
      }
      await this.$store.dispatch("SET_LOADING", false);
    },
    async loadLastTime() {
      this.lastTime = await this.$store.dispatch("FETCH_FORECAST_LAST_TIME");
    },
    click(event) {
      this.latitude = event.latlng.lat;
      this.longitude = event.latlng.lng;
      this.markerLatLng = [this.latitude, this.longitude];
    }
  },
  watch: {
    stationId(newVal) {
      const marker = this.markers.find(x => x.id === newVal);
      this.center = marker.latLng;
    }
  }
};
</script>

<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>